import React, { useState, useEffect } from "react";
import { useFormContext, Controller } from "react-hook-form";
import Switch from "react-switch";

export const SwitchComp = ({
  name,
  label,
  title,
  disabled = false,
  num = 0,
  classLabel,
  inputGroup,
  toggleSection = null,
  checked,
  ...props
}) => {
  const methods = useFormContext();
  const [active, setActive] = useState(false);

  // When a `checked` prop is passed the switch is controlled by the parent
  // (it mirrors the live form value); otherwise it keeps its own mount-time
  // snapshot for backwards compatibility with the other call sites.
  const isControlled = checked !== undefined;
  const switchChecked = isControlled ? !!checked : active;

  const switchStyle = {
    offColor: "#cdd2d6",
    onColor: "#06c102",
    uncheckedIcon: false,
    checkedIcon: false,
    activeBoxShadow: "0 0 2px 3px #06c102",
    height: 24,
    width: 36,
    handleDiameter: 18,
  };

  useEffect(() => {
    if (!isControlled) {
      setActive(methods.getValues(name));
    }
  }, []);

  const onChange = (field, isChecked) => {
    field.onChange(isChecked);
    setActive(isChecked);
    if (toggleSection != null) {
      toggleSection(active);
    }
    methods.setValue(name, isChecked);
  };

  return (
    <>
      <div className={`grid-column col-${num} ${inputGroup}`}>
        <Controller
          control={methods.control}
          name={name}
          render={({ field }) => (
            <Switch
              {...field}
              disabled={disabled}
              checked={switchChecked}
              onChange={(isChecked) => {
                onChange(field, isChecked);
              }}
              {...switchStyle}
              {...props}
            />
          )}
        />
        <input
          type="checkbox"
          {...methods.register(name)}
          hidden
          checked={switchChecked}
        />
        <span className={`${classLabel} formSubTitle`}>{label}</span>
      </div>
    </>
  );
};
